import { render, staticRenderFns } from "./ScreenContainer.vue?vue&type=template&id=3312d0ba"
import script from "./ScreenContainer.vue?vue&type=script&lang=js"
export * from "./ScreenContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports